import { Injectable } from "@angular/core";
import { MatrixClass } from "@models/matrix-class"
import { PERIODS_BY_CAMPUS } from "./periods"
import { ConstData } from "./helpers";

export interface ConstData {
  title: string,
  value: any
};

@Injectable()
export class ConstantsHelpers {

  constructor() {}

  getObject(targetValue: any, constants: ConstData[]): ConstData {
    return constants.find((c: ConstData) => {
      let result: boolean
      if (typeof targetValue === 'object') {
        result = JSON.stringify(targetValue) === JSON.stringify(c.value)
      }
      else {
        result = c.value === targetValue 
      }
      return result
    })
  }

  getPeriodTimesForClass(matrixClass: MatrixClass) {
    return PERIODS_BY_CAMPUS[matrixClass.day.code][matrixClass.period - 1]
  }

  getValue(data: ConstData[], title: string) {
    return data.find((d) => d.title == title).value
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/constants/helpers.ts